import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    infoOpen: false,
    forgroundColor: true,
    realIndex: 0,
    totalIndex: 0,
    mouseInInfo: false
  },
  mutations: {
    setInfoOpen(state, payload) {
      state.infoOpen = payload;
    },
    setForgroundColor(state, payload) {
      state.forgroundColor = payload;
    },
    setRealIndex(state, payload) {
      state.realIndex = payload;
    },
    setTotalIndex(state, payload) {
      state.totalIndex = payload;
    },
    setMouseInInfo(state, payload) {
      state.mouseInInfo = payload;
    }
  }
});
